export default __webpack_public_path__ + "static/step_06-a747cf520a06d20bf40a0c7b3c333d05.png";